import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import IssueAttributesScrollableTooltipCell from './IssueAttributesScrollableTooltipCell';

class IssueAttributesAdminTableMappingsCell extends PureComponent {
  constructor(props) {
    super(props);

    this.getTypeName = this.getTypeName.bind(this);
  }

  getTypeName(mapping) {
    const mappedType = this.props.fieldIssueTypeEntitiesMap[mapping.mappedItemId];
    const parent = mappedType.parentId ? this.props.fieldIssueTypeEntitiesMap[mappedType.parentId] : null;

    return (
      <span key={mapping.id}>
        {mappedType.title}
        {parent && <span className="IssueAttributesAdminTableMappingsCell__parent">{` (${parent.title})`}</span>}
      </span>
    );
  }

  render() {
    const typeNames = this.props.mappings.map(this.getTypeName);
    return <IssueAttributesScrollableTooltipCell options={typeNames} container={this.props.container} />;
  }
}

IssueAttributesAdminTableMappingsCell.displayName = 'IssueAttributesAdminTableMappingsCell';

IssueAttributesAdminTableMappingsCell.propTypes = {
  mappings: PropTypes.arrayOf(PropTypes.object).isRequired,
  fieldIssueTypeEntitiesMap: PropTypes.object.isRequired,
  container: PropTypes.object.isRequired
};

export default IssueAttributesAdminTableMappingsCell;
